import Accordion from '../lib/accordion';

export default class BlockProductTabs {

  init() {

    if (this.outlets.tab) {
      this.outlets.tab.forEach((tab, i) => {
        tab.addEventListener('click', () => {
          this.showTab(i);
        });
      });
    }

    if (this.outlets.accordion) {
      this.outlets.accordion.forEach((accordion) => {
        new Accordion(accordion, '.block-product-tabs__mobile-panel');
      });
    }

  }

  showTab(i) {
    this.outlets.tab.forEach((tab, j) => {
      if (i !== j) {
        tab.classList.remove('state-selected');
      } else {
        tab.classList.add('state-selected');
      }
    });

    this.outlets.panel.forEach((panel, j) => {
      if (i !== j) {
        panel.classList.remove('state-selected');
      } else {
        panel.classList.add('state-selected');
      }
    });
  }
}
